import { useEffect, useRef, useState } from "react";
import useTimeout from "../hooks/useTimeout";
import { useScreenCloud } from "../ScreenCloudReactApp";
import { useSlideShowContext } from "./SlideShowProvider";

interface Props {
  url: string;
  in: boolean;
  isActive: boolean;
}

const slideAnimationDuration = 300;

const Slide = (props: Props): JSX.Element => {
  const { url, in: inProp, isActive } = props;
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const [loaded, setLoaded] = useState(false);

  const sc = useScreenCloud();
  // Default slide duration is 12 seconds for Pulse mode
  const slideDuration = (sc.config.slideDuration || 12) * 1000;

  const { onSlideFinished, onSlideExited } = useSlideShowContext();

  useTimeout(onSlideFinished, slideDuration, loaded && isActive);

  const prevInProp = useRef(inProp);

  const [transitionClass, setTransitionClass] = useState(
    inProp ? "animations-slide-active" : "animations-slide-preload"
  );

  useEffect(() => {
    if (inProp !== prevInProp.current) {
      if (inProp === true) {
        setTransitionClass("animations-slide-active");
      }
      if (inProp === false) {
        setTransitionClass("animations-slide-exit");
        setTimeout(() => {
          onSlideExited();
        }, slideAnimationDuration);
      }
    }
    prevInProp.current = inProp;
  }, [inProp, onSlideExited]);

  return (
    <div className={`slide ${transitionClass}`}>
      <iframe
        ref={iframeRef}
        src={url}
        height="100%"
        width="100%"
        title="canva-slide-iframe"
        onLoad={() => setLoaded(true)}
      ></iframe>
    </div>
  );
};

export default Slide;
